import { searchProductListBlueprint } from "@made-people/blueprint-search/blueprint";
import { searchSidebarSuggestionsStyling } from "@made-people/blueprint-search-sidebar/blueprint";

searchSidebarSuggestionsStyling.override({
  slots: {
    base: "flex flex-col pt-4 pb-20 lg:h-full lg:m-0 lg:min-w-[400px] overflow-scroll h-[80dvh] max-h-[80dvh] lg:max-h-none lg:w-[50vw]",
    searchInputContainer: "flex flex-row gap-4 justify-between",
    suggestionlist: "flex flex-col gap-2 mb-2",
    suggestionListButton: "underline cursor-pointer",
    heading: "px-component-x-spacing-xs lg:px-0 mb-3",
    closeButton: "px-3 [&>svg]:w-2.5",
    productSuggestionList:
      "grid grid-cols-3 gap-x-1 gap-y-2 mb-2 w-full mt-3 lg:mt-6",
  },
});

searchProductListBlueprint.override({
  slots: {
    productSuggestionList:
      "grid grid-cols-2 lg:grid-cols-3 gap-x-1 gap-y-2 mb-2 w-full mt-3 lg:mt-4",
    heading: "text-md mb-2",
  },
});
